import { render } from "./Lobby.vue?vue&type=template&id=3ec189f2&scoped=true"
import script from "./Lobby.vue?vue&type=script&lang=js"
export * from "./Lobby.vue?vue&type=script&lang=js"

import "./Lobby.vue?vue&type=style&index=0&id=3ec189f2&lang=scss&scoped=true"

import exportComponent from "/vercel/path3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ec189f2"]])

export default __exports__